import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';

@Injectable()
export class RdstationService {

  constructor(private http: HttpClient) { }

  createContact(data) {
    return this.http.patch(environment.apiURL + '/rd-station/contact', data);
  }

}
